export function renderProjects() {
    return `
      <article>
        <h2 class="post-title">Projects</h2>
        <div class="post-meta">Things I've Built</div>
        <div class="project-grid">
          <div class="project">
            <h3>Crescent</h3>
            <p>To come</p>
          </div>
        <div class="project">
            <h3>Disty</h3>
            <p>To come</p>
          </div>
        </div>
      </article>
    `
  }
